import { Checkbox } from "@mui/material";
import { GridHeaderCheckbox, type GridColumnHeaderParams } from "@mui/x-data-grid-premium";
import { use } from "react";
import GridSelectionContext from "./GridSelectionContext.ts";

const SelectAllHeaderCheckbox = (props: GridColumnHeaderParams) => {
  const state = use(GridSelectionContext);

  if (state === undefined) {
    return <GridHeaderCheckbox {...props} />;
  }

  return (
    <Checkbox
      checked={state.checked}
      indeterminate={state.indeterminate}
      onChange={(_event, checked) => state.onChange(checked)}
    />
  );
};

export default SelectAllHeaderCheckbox;
